import React, { useEffect, useState } from 'react';
import { useContext } from 'react';
import { getUserDetails } from '../../../../../util/lib';
import Close from '../../../../svg/IconV2-2/Close';
import Menu from '../../../../svg/quadrado/Menu';
import ThemeWrapper, { QUADRADO, VENUS } from '../../../factory/ThemeWrapper';
import AutoPopup from '../../../popup/AutoPopup/AutoPopup';
import SearchForm from '../../../SearchForm';
import { SideMenuContext } from '../../../sideMenu/SideMenuManager';
import { HEADER_PRIMARY_MENU, COLLAPSE_ALL, HIDE_TOP_NAV } from '../constants';
import HeaderCallouts from '../HeaderElements/HeaderCallouts';
import HeaderMenu from '../HeaderElements/HeaderMenu';
import SecondaryMenu from '../HeaderElements/SecondaryMenu';
import SiteLogo from '../HeaderElements/SiteLogo';

import './scss/HeaderBase.scss';
import MenuHB from '../../../../svg/IconV2-2/MenuHB';

const CLICK = 'click',
	SHOW = 'show',
	Wrapper = ({ withBootstrap = false, children = ''}  = {}) => {
		const childrenL = children || null;

		return withBootstrap ? <div className='container'>
			{childrenL}
		</div> : <>
			{childrenL}
		</>;
	};

const HeaderBase = ({ data = {}, meta = {}, activePage = '/', primaryMenuCssClass = 'left-menu-class', alphaBackground = false, className = '', theme = VENUS, pageMeta = {}, withBootstrap = false}, props) => {
	const navBarId = `${props.id || 'header'}-navbar`,
		{ 
			branding = {},
			primaryMenu = {},
			searchWidget = {},
			secondaryMenu = {},
			callouts = [],
			AutoPopup:autoPopup = {}
		} = data,
		{ 
			branding: brandingMeta = {},
			primaryMenu: primaryMenuMeta = {},
			secondaryMenu: secondaryMenuMeta = {},
			callouts: calloutsMeta = {},
			searchWidget: searchWidgetMeta = false,
			sideMenuToggle: sideMenuToggleMeta = {},
			mobileDisplayNav = COLLAPSE_ALL // TEUX DEUX 
		} = meta,
		userDetails = getUserDetails(),
		userName = userDetails ? userDetails.name : '',
		{ sideMenuData = {} } = useContext(SideMenuContext),
		{ 
			active: sideMenuActive  = false, 
			open: sideMenuOpen = false, 
			setOpenState: setSideMenuOpenState
		} = sideMenuData,
		[showCollapse, setShowCollapse] = useState(false),
		[toggleShowClicked, setToggleShowClicked] = useState(false);

	useEffect(() => {
		const document = window.document;

		if (document) {
			let clickTimer = 0;
			//dropdown-menu.sub-link
			const dropDownsList = document.querySelectorAll('.header-dropdown-menu a.dropdown-link'),
				onActiveMenuClick = (evt = '') => {
					if (evt && evt.preventDefault) {
						evt.preventDefault();
					}
				},
				onMenuClick = (evt = '') => {
					const target = evt && evt.currentTarget ? evt.currentTarget || '' : '';

					if (target && target.id) {
						const id = target.id,
							menuDropDown = document.querySelector(`[aria-labelledby="${id}"]`),
							targetParent = target.parentNode;


						if (menuDropDown && menuDropDown.classList) {
							const dropDownsMenuList = document.querySelectorAll('.dropdown-menu.sub-link');

							document.removeEventListener(CLICK, onDocClick, true);

							[...dropDownsMenuList].forEach((dropDownMenu = '') => {
								if (dropDownMenu && dropDownMenu.classList) {
									dropDownMenu.classList.remove(SHOW);
								}
							});

							if (target.removeEventListener) {
								target.removeEventListener(CLICK, onMenuClick);
							}

							if (target.addEventListener) {
								target.addEventListener(CLICK, onActiveMenuClick);
							}

							menuDropDown.classList.add(SHOW);

							window.clearTimeout(clickTimer);
					
							window.setTimeout(() => {
								if (targetParent && targetParent.classList) {
									targetParent.classList.add(SHOW);
								}
								document.addEventListener(CLICK, onDocClick, true);
							}, 100);
						}
					}

					if (evt && evt.preventDefault) {
						evt.preventDefault();
					}
				},
				onDocClick = (evt = '') => {
					const dropDownsMenuList = document.querySelectorAll('.dropdown-menu.sub-link');

					[...dropDownsMenuList].forEach((dropDownMenu = '') => {
						if (dropDownMenu && dropDownMenu.classList) {
							dropDownMenu.classList.remove(SHOW);
						}
					});

					document.removeEventListener(CLICK, onDocClick, true);

					[...dropDownsList].forEach((dropDown = '') => {
						if (dropDown) {
							const dropDownParent = dropDown.parentNode;

							if (dropDownParent && dropDownParent.classList) {
								dropDownParent.classList.remove(SHOW);
							}
						}
					});

					window.clearTimeout(clickTimer);
					
					clickTimer = window.setTimeout(() => {
						document.removeEventListener(CLICK, onDocClick, true);
						[...dropDownsList].forEach((dropDown = '') => {
							if (dropDown) {
								const dropDownParent = dropDown.parentNode;

								if (dropDownParent && dropDownParent.classList) {
									dropDownParent.classList.remove(SHOW);
								}

								if (dropDown.removeEventListener) {
									dropDown.removeEventListener(CLICK, onActiveMenuClick);
								}
								if (dropDown.addEventListener) {
									dropDown.addEventListener(CLICK, onMenuClick);
								}
							}
						});
					}, 100);
				};

			[...dropDownsList].forEach((dropDown = '') => {
				if (dropDown && dropDown.addEventListener) {
					dropDown.addEventListener(CLICK, onMenuClick);
				}
			});
			
			return () => {
				window.clearTimeout(clickTimer);
					
				document.removeEventListener(CLICK, onDocClick, true);

				[...dropDownsList].forEach((dropDown = '') => {
					if (dropDown && dropDown.removeEventListener) {
						dropDown.removeEventListener(CLICK, onMenuClick);
					}
				});
			}
		}
	}, []);

	useEffect(() => {
		if (sideMenuOpen) {
			const primaryMenu = document.querySelector(`#${navBarId}`);

			if (primaryMenu && primaryMenu.classList) {
				primaryMenu.classList.remove('show');
			}
		}
	}, [sideMenuOpen]);

	useEffect(() => {
			let timeout1 = 0,
				timeout2 = 0;

			const document = window ? window.document || '' : '',
				navbarCollapse = document ? document.querySelector('.navbar-collapse') : '';
				
			if (navbarCollapse && toggleShowClicked) {
				navbarCollapse.style.removeProperty("height");
				// console.log('vvvvv', navbarCollapse);
				navbarCollapse.classList.remove('collapse');
				navbarCollapse.classList.remove('show');
				
				if (showCollapse) {
					navbarCollapse.classList.add('collapsing');
					timeout1 = window.setTimeout(() => {
						navbarCollapse.style.height = '323px';
					}, 200);
				} else {
					navbarCollapse.style.height = '332px';
					navbarCollapse.classList.add('collapsing');
					timeout1 = window.setTimeout(() => {
						navbarCollapse.style.height = '3px';
					}, 10);
				}
				timeout2 = window.setTimeout(() => {
					navbarCollapse.classList.remove('collapsing');
					navbarCollapse.style.removeProperty("height");
					if (showCollapse) {
						navbarCollapse.classList.add('show');
					}
					navbarCollapse.classList.add('collapse');
				}, 400);
			}

			return () => {
				window.clearTimeout(timeout1);
				window.clearTimeout(timeout2);
			}
		
	}, [showCollapse]);


	return (
		<nav className={`navbar navbar-expand-lg navbar-dark site-header-v2 sticky-top${className ? ' ' + className : ''} ${mobileDisplayNav ===  COLLAPSE_ALL? 'collapse-all' : 'no-collapse-all'}${alphaBackground ? ' alpha-bg' : ''}`}>
			<Wrapper withBootstrap={withBootstrap}>
				<span className='brand-sidemenu'>
					{sideMenuToggleMeta && sideMenuActive && <button type="button" className="side-menu-toggler"
						onClick={() => {
							if (setSideMenuOpenState) {	
								setSideMenuOpenState(!sideMenuOpen);
							}
						}}
					>
						{theme === QUADRADO ? <>{sideMenuActive && sideMenuOpen ? <Close /> : <Menu/>}</> : <span className="navbar-toggler-icon vt vt-menu"></span>}
					</button>}
					{brandingMeta.canShow && <SiteLogo data={branding} />}
				</span>
				{mobileDisplayNav === COLLAPSE_ALL && <button
					onClick={() => {	
						setToggleShowClicked(true);
						setShowCollapse(!showCollapse);
						if (setSideMenuOpenState) {
							setSideMenuOpenState(false);
						}
					}}
					className="navbar-toggler"
					type="button"
					data-toggle="collapse"
					data-target={`#${navBarId}`}
					aria-controls={navBarId}
					aria-expanded="false"
					aria-label="Toggle navigation">
					{theme === QUADRADO ? <Menu	/> : <span className="navbar-toggler-icon vt vt-menu"><MenuHB /></span>}
				</button>}
				<div className="collapse navbar-collapse" id={navBarId}>
					{primaryMenuMeta.canShow && <HeaderMenu
						id={HEADER_PRIMARY_MENU}
						data={primaryMenu}
						activePage={activePage}
						primaryMenuCssClass={`${primaryMenuCssClass}${primaryMenuMeta.centered ? ' menu-center' : ''}`}
					/>}
					{mobileDisplayNav !== HIDE_TOP_NAV && <>
						{pageMeta.canShowSearchBoxYN && searchWidgetMeta.canShow && <SearchForm data={searchWidget} inline={true} id={"lf_111"} onDataChange={() => { return; }} />}
						{calloutsMeta.canShow && <HeaderCallouts data={callouts} />}
						{secondaryMenuMeta.canShow && <SecondaryMenu userName={userName} data={secondaryMenu} meta={secondaryMenuMeta}/>}
					</>}
				</div>
				{mobileDisplayNav === HIDE_TOP_NAV && <div className="right-nav-area">
					{pageMeta.canShowSearchBoxYN && searchWidgetMeta.canShow && <SearchForm data={searchWidget} inline={true} id={"lf_111"} onDataChange={() => { return; }} />}
					{calloutsMeta.canShow && <HeaderCallouts data={callouts} mobileDisplayNav={mobileDisplayNav}/>}
					{secondaryMenuMeta.canShow && <SecondaryMenu userName={userName} data={secondaryMenu} meta={secondaryMenuMeta} mobileDisplayNav={mobileDisplayNav}/>}
				</div>}
				{autoPopup && <AutoPopup id="header-autopopup" data={autoPopup} />}
			</Wrapper>
		</nav >
	);
}

export default ThemeWrapper(HeaderBase);